module.exports = __webpack_public_path__ + "img/03.01680257.png";